import { Button } from "antd";
import React, { useEffect } from "react";
import './style.scss';
import LOGOAERICULTURE from '../../assets/image/logo/logologin.jpg';

// PKCE helper functions
function base64urlencode(str) {
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

async function pkceChallengeFromVerifier(verifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await window.crypto.subtle.digest('SHA-256', data);
  return base64urlencode(digest);
}

function generateRandomString(length) {
  const array = new Uint32Array(length);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
}

export default function LoginPage() {
  // PKCE login
  const clientId = "bkn-agr-service";
  const redirectUri = "https://service.agr.ku.ac.th";
  const authUrl = "https://alllogin.ku.ac.th/realms/KU-Alllogin/protocol/openid-connect/auth";

  // On mount, check for code in URL (ไม่ต้องแลก token เอง ให้ redirect ไป Landing แทน)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    if (code) {
      // Redirect to landing page with code (LandingPage จะจัดการต่อ)
      window.location.replace(`/?code=${code}`);
    }
  }, []);

  // Handle PKCE login button
  const handleLogin = async () => {
    const codeVerifier = generateRandomString(64);
    const codeChallenge = await pkceChallengeFromVerifier(codeVerifier);
    sessionStorage.setItem('pkce_code_verifier', codeVerifier);
    const params = new URLSearchParams({
      response_type: 'code',
      client_id: clientId,
      redirect_uri: redirectUri,
      scope: 'basic openid',
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      state: ''
    });
    window.location.href = `${authUrl}?${params.toString()}`;
  };

  return (
    <div className="wrap-login-page">
      <div className="wrap-login-content">
        <img style={{ height: '70px', marginBottom: '5px' }} src={LOGOAERICULTURE} alt="logo-agriculture" />
        <div className="wrap-label-login-page">
          <p>ระบบสารสนเทศสำหรับนิสิต</p>
          <p>คณะเกษตร มหาวิทยาลัยเกษตรศาสตร์</p>
        </div>
        <div className="login-box-yellow"></div>
        <div className="wrap-login-form">
          <Button className="btn-login" onClick={handleLogin}>Login</Button>
        </div>
      </div>
    </div>
  );
}

// ฟังก์ชันต่ออายุ access token ด้วย refresh token
export async function refreshAccessToken() {
  const clientId = "bkn-agr-service";
  const tokenUrl = "https://alllogin.ku.ac.th/realms/KU-Alllogin/protocol/openid-connect/token";
  const refreshToken = sessionStorage.getItem('refresh_token');
  if (!refreshToken) return null;
  const body = new URLSearchParams({
    grant_type: 'refresh_token',
    refresh_token: refreshToken,
    client_id: clientId
  });
  try {
    const res = await fetch(tokenUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body
    });
    const data = await res.json();
    if (data.access_token) {
      sessionStorage.setItem('access_token', data.access_token);
      if (data.refresh_token) {
        sessionStorage.setItem('refresh_token', data.refresh_token);
      }
      return data.access_token;
    } else {
      // refresh token หมดอายุ
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('refresh_token');
      window.location.replace('/login');
      return null;
    }
  } catch (err) {
    alert('Refresh token error: ' + err);
    return null;
  }
}